import type { AmazonOrderRequestProduct } from '@rye-com/rye-data-layer';
import { AmazonItemCatalogCard } from 'components/Orders/OrderDetailsCards/OrderDetailsCardTable/AmazonOrderDetailsCardTable/ItemCatalogCard/amazonItemCatalogCard';
import { useQuery } from '@apollo/client';
import { GET_PRODUCTS_BY_IDS } from '../../../../../../app/graphql';
import { AmazonProduct, Marketplace } from '../../../../../../app/graphql/generated/cart/graphql';

interface ItemCatalogCardValue {
  amazonProducts: AmazonOrderRequestProduct[];
}

export const AmazonItemCatalogCardTable = (props: ItemCatalogCardValue) => {
  const { loading, data } = useQuery(GET_PRODUCTS_BY_IDS, {
    variables: {
      input: props.amazonProducts.map((amazonProduct) => {
        return { id: amazonProduct.productId, marketplace: Marketplace.Amazon };
      }),
    },
  });

  if (loading) {
    return null;
  }

  const productMap: Record<string, AmazonProduct | undefined> = {};
  data?.productsByIds?.products?.forEach((product: AmazonProduct | null) => {
    if (product) {
      productMap[product.id] = product;
    }
  });

  return (
    <table className="item-catalog-table">
      <tbody>
        <tr className="item-catalog-table-header-row">
          <th>Item</th>
          <th>Product</th>
          <th>Quantity</th>
          <th>Price</th>
        </tr>
        {props.amazonProducts.map((amazonProduct) => (
          <AmazonItemCatalogCard
            key={amazonProduct.productId}
            quantityMap={props.amazonProducts}
            productId={amazonProduct.productId}
            price={amazonProduct.price}
            amazonProduct={productMap[amazonProduct.productId]}
          />
        ))}
      </tbody>
    </table>
  );
};
